import { api } from '@/api'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Referral } from './models'

export const useReferralsCounts = () => {
  return useQuery({
    queryKey: ['USER_REFERRAL_COUNTS'],
    queryFn: () =>
      api.get<{
        activatedCount: number
        notActivatedCount: number
        totalCount: number
      }>(`/user/referrals/activation-stats`),
    staleTime: 50_000,
    placeholderData: keepPreviousData
  })
}

export const useReferralsPoints = () => {
  return useQuery({
    queryKey: ['USER_REFERRAL_POINTS'],
    queryFn: () =>
      api.get<{
        totalPoints: number
      }>(`/user/stats/referral-points-total`),
    staleTime: 50_000,
    placeholderData: keepPreviousData,
    retry: 0
  })
}

export const useReferralAliases = () => {
  return useQuery({
    queryKey: ['USER_REFERRAL_ALIASES'],
    queryFn: () => api.get<{ items: { alias: string; isCurrent: boolean }[] }>(`/user/referrals/aliases`),
    staleTime: 50_000,
    placeholderData: keepPreviousData
  })
}

export const useSaveReferralCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (alias: string) => api.post(`/user/referrals/alias`, { alias }),
    onSuccess: async () => {
      queryClient.refetchQueries({ queryKey: ['USER_REFERRAL_ALIASES'] })
    },
    onError: (error) => {
      console.error(error)
    }
  })
}

export const useCheckReferralCode = () => {
  return useMutation({
    mutationFn: (alias: string) => api.post<{ available: boolean }>(`/user/referrals/alias/check`, { alias }),
    onSuccess: async () => {},
    onError: (error) => {
      console.error(error)
    }
  })
}

export const useTopReferrals = () => {
  return useQuery({
    queryKey: ['USER_TOP_REFERRALS'],
    queryFn: () => api.get<{ items: Referral[] }>(`/user/referrals/top?limit=10`),
    staleTime: 50_000,
    placeholderData: keepPreviousData
  })
}
